import api from './api';

const subscriptionService = {
  // Subscription Plan methods
  async getAllSubscriptionPlan(params = {}) {
    try {
      const response = await api.get('/admin/sub_plan', { params });
      return response;
    } catch (error) {
      console.error('Error fetching subscription plans:', error);
      throw error;
    }
  },

  async getSingleSubscriptionPlan(planId) {
    try {
      const response = await api.get(`/admin/sub_plan/${planId}`);
      return response;
    } catch (error) {
      console.error('Error fetching subscription plan:', error);
      throw error;
    }
  },

  async setSubscriptionPlanOrder(payload) {
    try {
      const response = await api.post('/admin/sub_plan_order/', payload);
      return response;
    } catch (error) {
      console.error('Error setting subscription plan order:', error);
      throw error;
    }
  },

  async addSubscriptionPlan(payload) {
    try {
      const response = await api.post('/admin/sub_plan/', payload);
      return response;
    } catch (error) {
      console.error('Error adding subscription plan:', error);
      throw error;
    }
  },

  async setSubscriptionStatus(payload) {
    try {
      const { plan_id, status } = payload;
      const response = await api.patch(`/admin/sub_plan/${plan_id}/${status}`);
      return response;
    } catch (error) {
      console.error('Error setting subscription status:', error);
      throw error;
    }
  },

  async editSubscriptionPlan(planId, payload) {
    try {
      const response = await api.put(`/admin/sub_plan/${planId}`, payload);
      return response;
    } catch (error) {
      console.error('Error editing subscription plan:', error);
      throw error;
    }
  },

  async saveSubscriptionPlan(payload) {
    try {
      const response = await api.post('/admin/sub_plan', payload);
      return response;
    } catch (error) {
      console.error('Error saving subscription plan:', error);
      throw error;
    }
  },

  // Subscription Plan Features methods
  async getAllSubscriptionPlanFeatures(params = {}) {
    try {
      const { perPage, currentPage, searchText } = params;
      const response = await api.get(`/admin/sub_plan_feature?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`);
      return response;
    } catch (error) {
      console.error('Error fetching subscription plan features:', error);
      throw error;
    }
  },

  async getSingleSubscriptionPlanFeatures(planFeaturesId) {
    try {
      const response = await api.get(`/admin/sub_plan_feature/${planFeaturesId}`);
      return response;
    } catch (error) {
      console.error('Error fetching subscription plan feature:', error);
      throw error;
    }
  },

  async addSubscriptionPlanFeatures(payload) {
    try {
      const response = await api.post('/admin/sub_plan_feature/', payload);
      return response;
    } catch (error) {
      console.error('Error adding subscription plan feature:', error);
      throw error;
    }
  },

  async editSubscriptionPlanFeatures(planFeaturesId, payload) {
    try {
      const response = await api.put(`/admin/sub_plan_feature/${planFeaturesId}`, payload);
      return response;
    } catch (error) {
      console.error('Error editing subscription plan feature:', error);
      throw error;
    }
  },

  // Analytics methods
  async getAllActiveSubs() {
    try {
      const response = await api.get('/admin/get-active-subs');
      return response;
    } catch (error) {
      console.error('Error fetching active subscriptions:', error);
      throw error;
    }
  },

  async getSubsForAnalysis(payload) {
    try {
      const { startDate, endDate } = payload;
      const response = await api.post(`/admin/subs-analysis?startDate=${startDate}&endDate=${endDate}`, payload);
      return response;
    } catch (error) {
      console.error('Error fetching subscription analysis:', error);
      throw error;
    }
  }
};

export default subscriptionService;
